import React from 'react'
import Dropdown from './Dropdown/index'
import { ARTWORK_TECHNIQUE_NAME } from '../../../util/constants'

export default function AdminPanelDropdowns() {
	return (
		<>
			<div className='dropdownsContainer'>
				<Dropdown name={ARTWORK_TECHNIQUE_NAME} />
			</div>
		</>
	)
}
